import { useState, useEffect } from "react";
import DialogComponent, { DrawerComponent, Modal } from "src/components/DialogComponent";
import Button from "src/components/Button";
import TGButton from "src/components/ui/TGButton";
import { useAppDispatch, useAppSelector } from "src/hooks/redux";
import _, { isArray } from "lodash";
import { addItemRequest, getItemsRequest } from "src/modules/spItems/api";
import { selectCurrentUser, selectUsers } from "src/modules/users/selector";
import Form from "src/components/Form";
import { selectItems } from "src/modules/spItems/selectors";
import { myTasksIncidentstListName, myTasksIncidentsQuestionsListName, myTasksTypeIncidentsListName } from "src/api/config/myTasksInc.config";
import { myTasksDependListName, myTasksLocationsListName } from "src/api/config/myTasksLists.config";
import { getItems } from "src/modules/spItems/actions";
import moment from "moment";
import { useSearchParams, useNavigate } from "react-router-dom";
import LoadingOpBg from "src/components/LoadingOpBg";
import { equipmentsListName, paramsListName } from "src/api/config";
import { incStatus, incTypes } from "src/api/config/systemSwitch";
import { autoCloseModal } from "src/constants";

const AddSecurity = ({ zIndex }: { zIndex: number }) => {
    const dispatch = useAppDispatch();
    const currentUser: any = useAppSelector((state) => selectCurrentUser(state));
    const [open, setOpen] = useState(false);
    const [cancel, setCancel] = useState(false);
    const [addInc, setAddInc] = useState(false);
    const [closeAllModals, setCloseAllModals] = useState(false);
    const [fields, setFields] = useState<any>([]);
    const [dependenceFields, setDependenceFields] = useState<any>({
        Location: null,
        Department: null,
        Region: null
    });
    const [formData, setFormData] = useState<any>(null);
    const [defaultValues, setDefaultValues] = useState<any>({
        TypeIncident: 'Security'
    });

    const users: any = useAppSelector(selectUsers);

    const [customLoading, setCustomLoading] = useState(false);
    const [incQuestions, setIncQuestions] = useState<any>([]);

    const locations: any = useAppSelector(state => selectItems(state, myTasksLocationsListName));
    const dependencies: any = useAppSelector(state => selectItems(state, myTasksDependListName));
    const typesIncList: any = useAppSelector(state => selectItems(state, myTasksTypeIncidentsListName));
    const [incIDAdd, setIncIDAdd] = useState<any>(null);
    const [query, setQuery] = useSearchParams();
    const [renderInc, setRenderInc] = useState(false);
    const [incKeys, setIncKeys] = useState<any>([]);
    const [currentTypeInc, setCurrentTypeInc] = useState<any>('Security');
    const [typesInc, setTypesInc] = useState<any>([]);
    const [currentFormData, setCurrentFormData] = useState<any>(null);
    const navigate = useNavigate();
    const params: any = useAppSelector((state) => selectItems(state, paramsListName));

    //Расставляем опции селектов локации, типа сотрудников
    useEffect(() => {
        if (currentUser.id && renderInc) {
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (tempFieldsForm[i]['key'] === 'Location') {
                    const options = locations.filter((location: any) => {
                        if (currentUser.isSecurityAdmin || currentUser.isAdmin || (currentUser.isLocationEditorMyTasks && currentUser.isLocationEditorMyTasks.length > 0 && currentUser.isLocationEditorMyTasks.find((locationID: any) => locationID === location.ID)) || (currentUser.isLocationAdminMyTasks && currentUser.isLocationAdminMyTasks.length > 0 && currentUser.isLocationAdminMyTasks.find((locationID: any) => locationID === location.ID))) {
                            return true
                        } else {
                            return false
                        }
                    }).map((location: any) => {
                        return {
                            id: location.ID,
                            name: location.Title,
                            available: true
                        };
                    });
                    tempFieldsForm[i]['options'] = [...options];
                }
            }
            setFields([...tempFieldsForm]);
        }
    }, [locations, currentUser, renderInc]);

    useEffect(() => {
        if (dependenceFields["Location"] && renderInc) {
            dispatch(getItems({ listName: myTasksDependListName, filters: { Location: dependenceFields["Location"]["id"] } }));
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (tempFieldsForm[i]["key"] === "Department") {
                    tempFieldsForm[i]["disabled"] = false;
                }
                if (tempFieldsForm[i]["key"] === "Region") {
                    tempFieldsForm[i]["disabled"] = true;
                }
            }
            setFields([...tempFieldsForm]);
        }
        if (!dependenceFields["Location"] && renderInc) {
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (tempFieldsForm[i]["key"] === "Department" || tempFieldsForm[i]["key"] === "Region") {
                    tempFieldsForm[i]["disabled"] = true;
                }
            }
            setFields([...tempFieldsForm]);
        }
        if (dependenceFields["Department"] && renderInc) {
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (tempFieldsForm[i]["key"] === "Region") {
                    tempFieldsForm[i]["disabled"] = false;
                }
            }
            setFields([...tempFieldsForm]);
        }
    }, [dependenceFields, renderInc]);

    //В списке зависимостей колонка называется Departament, а в списках с аудитами и отделами Department (буква a отличие)

    useEffect(() => {
        if (renderInc) {
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                if (dependenceFields["Location"]) {
                    if (tempFieldsForm[i]["key"] === "Department") {
                        const options = dependencies
                            .filter((dependence: any) => dependence.Location.ID === dependenceFields["Location"]["id"])
                            .map((dependence: any) => {
                                return {
                                    id: dependence.Departament.ID,
                                    name: dependence.Departament.Title,
                                };
                            });
                        tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual);
                    }
                }
                if (dependenceFields["Department"]) {
                    if (tempFieldsForm[i]["key"] === "Region") {
                        const options = dependencies
                            .filter((dependence: any) => dependence.Location.ID === dependenceFields["Location"]["id"] && dependence.Departament.ID === dependenceFields["Department"]["id"])
                            .map((dependence: any) => {
                                return {
                                    id: dependence.Region.ID,
                                    name: dependence.Region.Title,
                                };
                            });
                        tempFieldsForm[i]["options"] = _.uniqWith(options, _.isEqual);
                    }
                }
            }
            setFields([...tempFieldsForm]);
        }
    }, [dependencies, renderInc]);

    useEffect(() => {
        setOpen(false);
        setCancel(false);
        setAddInc(false);
    }, [closeAllModals]);

    useEffect(() => {
        if (formData && Object.keys(formData).length > 0) {
            setCustomLoading(true);
            let tempIncObj: any = {};
            Object.keys(formData).map(key => {
                if (incKeys.some((incKey: string) => incKey === key)) {
                    if (Array.isArray(formData[key])) {
                        formData[key].sort((a: any, b: any) => {
                            return a.localeCompare(b);
                        });
                        tempIncObj[key] = formData[key];
                    } else {
                        tempIncObj[key] = formData[key];
                    }
                }
            });
            let closedDate = (typeof formData.DateIncidents.startDate === "string" && new Date(formData.DateIncidents.startDate)) || formData.DateIncidents.startDate;
            const days = Number(params.find((param: any) => param.Key === "IncSecurityDate")["Value"].trim());
            closedDate = moment(closedDate).add(days, 'days').toDate();
            const sendData = {
                Questions: JSON.stringify(tempIncObj),
                TypeIncident: incTypes.security,
                TimeIncident: formData.TimeIncident,
                Responsible: formData.Responsible[0]["value"],
                ResponsibleEmail: formData.Responsible[0]["value"],
                Title: `Инцидент. Security. От ${moment((typeof formData.DateIncidents.startDate === "string" && new Date(formData.DateIncidents.startDate)) || formData.DateIncidents.startDate).format('DD.MM.YYYY')}`,
                DateIncidents: (typeof formData.DateIncidents.startDate === "string" && new Date(formData.DateIncidents.startDate)) || formData.DateIncidents.startDate,
                Location: formData.Location.id,
                Department: formData.Department.id,
                Region: formData.Region.id,
                Description: formData.Description.trim() + " ",
                AuthorEmail: currentUser.email,
                ClosedDate: closedDate,
                Status: incStatus.process // В процессе
            }
            // console.log('sendData: ', sendData);
            addItemRequest({ listName: myTasksIncidentstListName, body: sendData }).then(incID => {
                setIncIDAdd(incID);
                setAddInc(true);
                setCustomLoading(false);
            });
        }
    }, [formData]);

    useEffect(() => {
        if (incQuestions.length > 0) {
            let tempKeys: any = [];
            tempKeys = incQuestions.filter((field: any) => field.condition).map((field: any) => field.key);
            setIncKeys([...tempKeys]);
            setFields([...incQuestions]);
            setRenderInc(true);
        }
    }, [incQuestions]);

    useEffect(() => {
        if (currentTypeInc) {
            setRenderInc(false);
            setCustomLoading(true);
            getItemsRequest({ listName: myTasksIncidentsQuestionsListName, filters: { TypeIncident: incTypes.security }, sortOrder: { name: 'Order0', asc: true } }).then((results) => {
                const tempIncQuestions = [...results.items];
                let incFieldsForm: any = [];
                incFieldsForm = [...incFieldsForm, ...[
                    {
                        type: 'date',
                        require: true,
                        key: 'DateIncidents',
                        title: 'Дата несоответствия/инцидента',
                        minDate: moment(new Date()).subtract(7, 'days').toDate(),
                        maxDate: moment(new Date()).toDate(),
                        placeholder: 'дд.мм.гггг',
                        condition: null,
                        width: 'w-[calc(50%-10px)]'
                    },
                    {
                        type: 'time',
                        require: false,
                        key: 'TimeIncident',
                        title: 'Время несоответствия/инцидента',
                        placeholder: 'чч:мм',
                        condition: null,
                        width: 'w-[calc(50%-10px)]'
                    }
                ]];
                incFieldsForm = [...incFieldsForm, ...[
                    {
                        type: 'peoplePicker',
                        require: true,
                        single: true,
                        key: 'Responsible',
                        title: 'ФИО инициатора',
                        current: true,
                        condition: null,
                        placeholder: 'Введите имя или фамилию',
                        width: 'w-[calc(50%-10px)]'
                    },

                    {
                        type: 'select',
                        require: true,
                        key: 'Location',
                        title: 'Локация, где произошло несоответствие/инцидент',
                        placeholder: 'Не выбрано',
                        condition: null,
                        width: 'w-[calc(50%-10px)]'
                    },
                    {
                        type: 'select',
                        require: true,
                        key: 'Department',
                        title: 'Отдел, где произошло несоответствие/инцидент',
                        placeholder: 'Не выбрано',
                        condition: null,
                        width: 'w-[calc(50%-10px)]'
                    },
                    {
                        type: 'select',
                        require: true,
                        key: 'Region',
                        title: 'Участок, где произошло несоответствие/инцидент',
                        placeholder: 'Не выбрано',
                        condition: null,
                        width: 'w-[calc(50%-10px)]'
                    },
                    {
                        type: 'textArea',
                        key: 'Description',
                        require: true,
                        title: 'Описание',
                        condition: null,
                        noticeIcon: true,
                        notice: `<span class="w-full"><strong>Что?</strong> (Что случилось, в чем именно проблема?)<br/>
            <strong>Где?</strong> (Где именно проблема в продукте/процессе и где была обнаружена?) <br/>
            <strong>Когда?</strong> (Когда проблема началась, когда была обнаружена?) <br/>
            <strong>Как?</strong> (Есть ли стандарт и соблюдался ли он на момент возникновения проблемы?) <br/>
            <strong>Кто?</strong> (Кто обнаружил проблему?) <br/>
            <strong>Насколько велика проблема?</strong> (Количество затронутого продукта / минуты простоя, риски от проблемы)<span>`,
                        placeholder: 'ЧТО? (Что случилось, в чем именно проблема?) ГДЕ? (Где именно проблема в продукте/процессе и где была обнаружена?) КОГДА? (Когда проблема началась, когда была обнаружена?) КАК? (Есть ли стандарт и соблюдался ли он на момент возникновения проблемы?) КТО? (Кто обнаружил проблему?) НАСКОЛЬКО ВЕЛИКА ПРОБЛЕМА? (Количество затронутого продукта / минуты простоя, риски от проблемы)',
                        width: 'w-full'
                    }
                ]];
                tempIncQuestions.forEach((item) => {
                    if (item.TypeQuestion === 'select') {
                        incFieldsForm = [...incFieldsForm, {
                            type: item.TypeQuestion,
                            require: item.Require,
                            key: item.Key,
                            title: item.Title,
                            hide: item.DefaultHide,
                            notice: item.Notice,
                            noticeIcon: item.Notice && true || false,
                            width: item.Width,
                            placeholder: 'Не выбрано',
                            condition: item.Condition && JSON.parse(item.Condition),
                            options: item.Options && item.Options.split(";").map(option => {
                                return {
                                    id: option.trim(),
                                    name: option.trim()
                                }
                            }) || []
                        }]
                    } else if (item.TypeQuestion === 'radio' || item.TypeQuestion === 'checkbox') {
                        incFieldsForm = [...incFieldsForm, {
                            type: item.TypeQuestion,
                            require: item.Require,
                            key: item.Key,
                            notice: item.Notice,
                            noticeIcon: item.Notice && true || false,
                            title: item.Title,
                            hide: item.DefaultHide,
                            width: item.Width,
                            condition: item.Condition && JSON.parse(item.Condition),
                            optionsInputs: item.Options && item.Options.split(";").map(option => option.trim()) || []
                        }]
                    } else if (item.TypeQuestion === 'number' || item.TypeQuestion === 'input') {
                        incFieldsForm = [...incFieldsForm, {
                            type: item.TypeQuestion,
                            require: item.Require,
                            key: item.Key,
                            title: item.Title,
                            disabled: item.Disabled,
                            notice: item.Notice,
                            noticeIcon: item.Notice && true || false,
                            placeholder: 'Введите значение',
                            hide: item.DefaultHide,
                            width: item.Width,
                            condition: item.Condition && JSON.parse(item.Condition),
                            default: item.Options
                        }]
                    } else if (item.TypeQuestion === "textArea") {
                        incFieldsForm = [...incFieldsForm, {
                            type: item.TypeQuestion,
                            require: item.Require,
                            key: item.Key,
                            title: item.Title,
                            notice: item.Notice,
                            noticeIcon: item.Notice && true || false,
                            disabled: item.Disabled,
                            placeholder: 'Введите значение',
                            hide: item.DefaultHide,
                            width: item.Width,
                            condition: item.Condition && JSON.parse(item.Condition),
                            default: item.Options
                        }]
                    }
                });
                setIncQuestions([...incFieldsForm]);
                setCustomLoading(false);
            });
        } else {
            setRenderInc(true);
        }
    }, [currentTypeInc]);

    useEffect(() => {
        if (!addInc && incIDAdd) {
            const newSearchParams = new URLSearchParams(query);
            newSearchParams.set("securityCard", incIDAdd.toString());
            setQuery(newSearchParams);
            setFormData(null);
            setIncIDAdd(null);
        }
    }, [addInc]);

    useEffect(() => {
        if (renderInc && currentFormData) {
            // console.log('currentFormData_add: ', currentFormData);
            let tempCurrentFromData = { ...currentFormData, ...{ TypeIncident: "Security" } }
            const tempFieldsForm = [...fields];
            for (let i = 0; i < tempFieldsForm.length; i++) {
                const field = tempFieldsForm[i];
                if (field.condition) {
                    let conditionObj: any = {};
                    Object.keys(field.condition).map((key: string) => {
                        if (typeof tempCurrentFromData[key] === 'object') {
                            if (tempCurrentFromData[key]['name'] === field.condition[key]) {
                                conditionObj[key] = true;
                            }
                        } else {
                            if (tempCurrentFromData[key] === field.condition[key]) {
                                conditionObj[key] = true;
                            }
                        }
                    });
                    if (Object.keys(field.condition).length === Object.keys(conditionObj).length) {
                        tempFieldsForm[i]['hide'] = false;
                    } else {
                        tempFieldsForm[i]['hide'] = true;
                    }
                }
            }
            setFields([...tempFieldsForm]);
        }
    }, [currentFormData, renderInc]);

    return (
        <>
            <Button open={open} setOpen={setOpen} typeIcon="add" classBg="btn-dark" text="Создать новую форму" icon={true} />

            <DrawerComponent setOpenCustomModal={setCancel} zIndex={zIndex} open={open} toggleDrawer={setOpen}>
                {customLoading &&
                    <LoadingOpBg />
                }
                <div className="flex flex-col p-10 shrink">
                    <h1 className="mb-8 text-black">Страница создания инцидента по Security</h1>
                    <Form
                        type="add_my_tasks_inc_security"
                        setFormData={setFormData}
                        fieldsForm={[...fields]}
                        setCurrentTypeInc={setCurrentTypeInc}
                        setCurrentFormData={setCurrentFormData}
                        setOpenCancelAddCard={setCancel}
                        openCancelAddCard={cancel}
                        defaultValues={defaultValues}
                        setDependenceFields={setDependenceFields}
                    />
                </div>
            </DrawerComponent>

            <Modal zIndex={zIndex ? zIndex + 10 : 70} modalClassName="min-h-px" open={cancel} toggleDialog={setCancel}>
                <header className="px-10 pb-4">
                    <h2>Вы действительно хотите отменить изменения?</h2>
                </header>

                <div className="px-10 py-5">
                    <p>
                        При нажатии на “Отмена” возврат действий будет невозможен
                    </p>
                </div>

                <footer className="flex justify-center justify-between w-full px-10 pt-10 mt-4 border-t">
                    <TGButton color="white" onClick={(e) => setCancel(false)}>
                        Закрыть
                    </TGButton>
                    <TGButton color="bluedark" onClick={(e) => setCloseAllModals(!closeAllModals)}>
                        Подтвердить отмену
                    </TGButton>
                </footer>
            </Modal>
            <Modal zIndex={zIndex ? zIndex + 10 : 70} modalClassName="min-h-px" open={addInc} toggleDialog={setAddInc} autoClose={autoCloseModal}
                onAutoClose={() => {
                    setCloseAllModals(!closeAllModals);
                }}>
                <header className="px-10 pb-4">
                    <h2>Вы успешно сохранили форму</h2>
                </header>

                <div className="px-10 py-5">
                    <p>
                        Форма сохранена со всеми изменениями
                    </p>
                </div>

                <footer className="flex justify-center w-full px-10 pt-10 mt-4 border-t">
                    <TGButton color="bluedark" onClick={(e) => setCloseAllModals(!closeAllModals)}>
                        Закрыть
                    </TGButton>
                </footer>
            </Modal>
        </>
    );
};

export default AddSecurity;
